import { cn, FOCUS_RING } from '@/components/base'

/**
 * A product's colour, as a ring around a filled circle.
 *
 * The fill is an inline colour because it is the product's own value out of
 * the database, not a colour the palette owns. A product without one falls
 * back to a token, so an empty swatch still follows the theme.
 */
export function ColorDot({
  hex,
  size = 20,
  onClick,
  label,
}: {
  hex?: string | null
  size?: number
  onClick?: () => void
  /** Names the swatch where it is a control. */
  label?: string
}) {
  const dot = (
    <span
      className="flex items-center justify-center rounded-full border-2 border-border"
      style={{ width: size, height: size }}
    >
      <span
        className={cn('rounded-full', !hex && 'bg-border')}
        style={{
          width: size - 10,
          height: size - 10,
          backgroundColor: hex ?? undefined,
        }}
      />
    </span>
  )

  if (!onClick) return dot

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      className={`transition-opacity hover:opacity-80 ${FOCUS_RING}`}
    >
      {dot}
    </button>
  )
}
